import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { MemberService } from '../_service/member.service';
import { LeadsService } from '../_service/leads.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { PageEvent,MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css']
})
export class MemberComponent implements OnInit {
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;sc3Url:string='';
  search:string;userId:string;memberList=[];circles=[];circle:string;submitted:boolean=false;
  uploaded_msg:string='';payment_mode=[];package_type=[];normal_corporate_bds=[];bds_copy=[];pkg_type='';pmode='';nco_bds='';start_date:string='';end_date:string='';

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUploadTransactionData', {static: false}) csvUploadTransactionData: ElementRef;

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  constructor(private leadapi:LeadsService,private memberapi:MemberService,private sharedapi:SharedService,private dialog:MatDialog,private activatedRoute: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url= localStorage.getItem('s3url');
    this.getcircle(); this.getPackageTypeList(); this.getMemberWithCorporateBDs();
    this.payment_mode=[
      {
        'value':'razorpay',
        'name':'Razorpay',
      },
      {
        'value':'paytm',
        'name':'Paytm',
      },
      {
        'value':'gpay',
        'name':'Gpay',
      },
      {
        'value':'cash',
        'name':'Cash',
      },
      {
        'value':'phonepay',
        'name':'Phonepay',
      }
    ];
  }

  ngAfterViewInit() {
    this.loadmembers(0,this.perpage);
  }

  setSearchValue(type)
  {
    if(type=='bds'){
        $("#bd_search").val('');
        $("#bd_search").focus();
        this.normal_corporate_bds= this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type)
  {
    if(type == 'bds'){
        this.normal_corporate_bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  resetFilters()
  {
    this.search = ''; this.circle = ''; this.pkg_type = ''; this.pmode = ''; this.nco_bds = '';
    this.clearDate();
    this.loadmembers(0,25);
  }

  async loadmembers(pageIndex,perpage)
  {
      this.paginator.pageIndex = pageIndex; 
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&circle='+this.circle+'&package_type='+this.pkg_type+'&payment_mode='+this.pmode+'&bds='+this.nco_bds+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.memberList = [];
      await this.memberapi.loadMemberData(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = data.totaldata;
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
            this.memberList = data.data;
          } 
          else 
          {
            this.memberList = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadmembers(event.pageIndex,event.pageSize);
  }

  exportMemberData()
  {
    if(this.memberList.length>0)
    {
        let data = [];
        let titles = ['Name','Email','Package','Payment Mode','Billed Amount','Share By','City','Circle','Date'];
        data.push(titles);
        for(let key in this.memberList)
        {
            let bd_details = '';
            if(this.memberList[key].bd_name){
              bd_details += this.memberList[key].bd_name;
              if(this.memberList[key].category_name){
                bd_details += ' ('+this.memberList[key].category_name+')';
              }
            } 
            else if(this.memberList[key].formbd_name){
              bd_details += this.memberList[key].formbd_name;
              if(this.memberList[key].category_name){
                bd_details += ' ('+this.memberList[key].category_name+')';
              }
            } 
            
            else {
              bd_details += 'NA';
            }

            let transaction_date ='';
            if(this.memberList[key].transaction_date){
              transaction_date = formatDate(this.memberList[key].transaction_date*1000, 'dd/MM/yyyy', 'en-US');
            }

            let payment_mode_str:string = this.memberList[key].payment_mode;
            payment_mode_str = payment_mode_str[0].toUpperCase() + payment_mode_str.slice(1);

            let exdata = [
              this.memberList[key].name,
              
              this.memberList[key].email,
              this.memberList[key].plan_name,
              payment_mode_str,
              this.memberList[key].billed_amount,
              bd_details,
              this.memberList[key].city_name,
              this.memberList[key].circle_name,
              transaction_date
              
            ];
            data.push(exdata);
        }


        let ws = XLSX.utils.aoa_to_sheet(data);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
        XLSX.writeFile(wb, 'member_'+utc+'.xlsx');
    }else{
        this.sharedapi.presentToast('No Member data found.');
    }
  }

  hideModalUploadPlanTransaction()
  {
    location.reload();
    $('#myModalPlanTransaction').modal('hide');
  }

  showModalUploadPlanTransaction()
  {
    $('#myModalPlanTransaction').modal();
  }

  async selectFileForUploadPlanTransaction(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.uploaded_msg = "";
      this.memberapi.uploadcsvForPlanTransaction(formData)
      .subscribe((data:any) => {
        this.submitted = false;
        this.csvUploadTransactionData.nativeElement.value = "";
        if(data.status)
        {
          this.uploaded_msg = data.msg;
        }
        else
        {
            this.sharedapi.presentToast(data.msg);
        }
      }, error =>
      {
          this.sharedapi.checkError(error);
      });
  }

  async getPackageTypeList()
  {
    await this.memberapi.getPackageType().subscribe((data:any) => {
        if(data.status)
        {
            this.package_type = data.data;
        }else{
            this.package_type = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getMemberWithCorporateBDs()
  {
    await this.memberapi.getMemberWithCorporateBDs().subscribe((data:any) => {
        if(data.status)
        {
            this.normal_corporate_bds = data.data;
            this.bds_copy = this.normal_corporate_bds;
        }else{
            this.normal_corporate_bds = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
  }

}
